import { Box } from "@chakra-ui/react";
import { stickyBottomBarFirstTriggerStyles } from "components/StickyBottomBar";
import StickyBottomBarTrigger from "components/StickyBottomBar/StickyBottomBarTrigger";
import { DataContextProvider } from "contexts/DataContext";
import { useLanguage } from "contexts/LocalizationContext";
import { MobileSideMenu } from "components/MobileSideMenu";
import { ModalContextProvider } from "contexts/ModalContext";
import { StickyBottomBarContextProvider } from "contexts/StickyBottomBarContext";
import CustomHead from "modules/common/components/CustomHead";
import Footer from "modules/common/components/Footer";
import { CheckCompensationButton, HeaderNav, MenuItems } from "modules/common/components/HeaderNav";
import { PressLogos } from "modules/common/components/PressLogos";
import StickyBottomBarAdapter from "modules/storyblok/adapters/StickyBottomBar";
import BreadcrumbsSchema from "modules/storyblok/components/BreadcrumbsSchema";
import { useTopMenu } from "hooks/useMenu";
import type { AirHelpScoreWrapperTemplateProps } from "./AirHelpScoreWrapper.d";

const AirHelpScoreWrapper = ({
  story,
  cmsLanguagesData,
  serverSideStoryblokPages,
  children,
  googleOptimizeExperimentIds,
  whiteListDomains,
  nofollowUrls,
}: AirHelpScoreWrapperTemplateProps) => {
  const {
    content: {
      metaTitle,
      metaDescription,
      breadcrumbsParentPage,
      breadcrumbsPositionName,
      stickyBottomBarHeading,
      hideStickyBottomBar,
      stickyBottomBarVariant,
    },
  } = story;

  const language = useLanguage();
  const topMenu = useTopMenu(language);

  return (
    <DataContextProvider
      data={{ cmsLanguagesData, serverSideStoryblokPages, googleOptimizeExperimentIds, whiteListDomains, nofollowUrls }}
    >
      <CustomHead title={metaTitle} description={metaDescription} />
      <BreadcrumbsSchema
        breadcrumbsPositionName={breadcrumbsPositionName}
        breadcrumbsParentPage={breadcrumbsParentPage}
      />

      <MobileSideMenu />
      <ModalContextProvider>
        <HeaderNav menuItems={<MenuItems menu={topMenu} />} headerButtons={<CheckCompensationButton />} />
        <StickyBottomBarTrigger type="first" styles={stickyBottomBarFirstTriggerStyles} />
        <Box pt={{ base: 32, lg: 40 }} as="main">
          {children}
        </Box>
        <PressLogos />
        <Footer />
      </ModalContextProvider>

      <StickyBottomBarAdapter
        showStickyBottomBar={!hideStickyBottomBar}
        stickyBottomBarVariant={stickyBottomBarVariant}
        stickyBottomBarHeading={stickyBottomBarHeading}
      />
    </DataContextProvider>
  );
};

export const AirHelpScoreAdapter = (props: AirHelpScoreWrapperTemplateProps) => (
  <StickyBottomBarContextProvider threshold={0.4}>
    <AirHelpScoreWrapper {...props} />
  </StickyBottomBarContextProvider>
);
